import dayjs from 'dayjs';
import floor from 'lodash/floor';
import dayjsMixin from '../../../../mixins/dayjs';

export default {
  name: 'CalendarYear',
  mixins: [dayjsMixin],
  model: {
    prop: 'value',
    event: 'change',
  },
  events: ['change', 'selected'],
  props: {
    value: {
      type: [String, Object],
      default: null,
    },
    total: {
      type: Number,
      default: 20,
    },
    navOffset: {
      type: Number,
      default: 20,
    },
  },
  data() {
    return {
      date: null,
      datePreview: null,
      year: null,
      yearOffset: 0,
      isSameDate: false,
      transitionEnterClass: '',
      transitionLeaveClass: '',
    };
  },
  computed: {
    yearOptions() {
      const options = [];

      const year = this.datePreview.year();
      const yearRounded = floor(year, -1) + 10;
      const yearStart = (yearRounded - this.total) + this.yearOffset;
      const yearEnd = yearRounded + this.yearOffset;

      for (let year = yearStart; year <= yearEnd; year++) {
        options.push({
          label: year,
          value: year,
        });
      }

      return options;
    },
  },
  watch: {
    value: {
      handler(value) {
        const date = dayjs(value);
        this.date = date.isValid() ? date : dayjs();
        if (!this.datePreview) this.datePreview = this.date;
        this.year = this.date.year();
      },
      immediate: true,
    },
    year(value) {
      this.date = this.date.year(value);
    },
    date(value, oldValue) {
      this.isSameDate = value.isSame(oldValue, 'year');
      this.emitEvent('change', value);
    },
  },
  methods: {
    selected() {
      this.emitEvent('selected', this.date, false);
    },
    setYear(value) {
      this.year = value;
      this.date = this.date.year(value);
      this.selected();
    },
    navNext() {
      this.yearOffset += this.navOffset;
      this.updateTransitionClass('next');
    },
    navPrev() {
      this.yearOffset -= this.navOffset;
      this.updateTransitionClass('prev');
    },
    emitEvent(name, value, checkDate = true, props = this.value) {
      if (typeof props === 'string') {
        this.$emit(name, value.toISOString());
      } else {
        if (checkDate) {
          if (!this.isSameDate) this.$emit(name, value);
        } else {
          this.$emit(name, value);
        }
      }
    },
    updateTransitionClass(direction) {
      if (direction === 'prev') {
        this.transitionEnterClass = 'animated fadeSlideInLeft';
        this.transitionLeaveClass = 'animated fadeSlideOutRight';
      }
      if (direction === 'next') {
        this.transitionEnterClass = 'animated fadeSlideInRight';
        this.transitionLeaveClass = 'animated fadeSlideOutLeft';
      }
    },
  },
};
